// 导入组件，组件必须声明 name
import dragButton from "./src/index.vue";
const mycomponent = dragButton;
// 为组件提供 install 安装方法，供按需引入
mycomponent.install = function(Vue) {
  Vue.component(mycomponent.name, mycomponent);
};
// 导出组件
export default mycomponent;



// WEBPACK FOOTER //
// ./src/packages/dragButton/index.js